import React,{useEffect} from 'react';
import ChangePlanHeader from 'components/ChangePlanHeader/ChangePlanHeader';
import RepaymentContainer from './components/RepaymentContainer/RepaymentContainer';
import PaymentContainer from 'components/PaymentContainer/PaymentContainer';
import PageLink from 'components/PageLink/PageLink';
import styles from './UpdatePaymentPlanChangePaymentTypeConfirmPageData.module.scss';
import RepaymentList from 'components/RepaymentList/RepaymentList';
import { getGTMVariables, getGTMVariablesPageView } from 'common/helpers/Gtm';
import TagManager from 'react-gtm-module';
interface Props {
  PageData?: any;
  Model?: any;
  LayoutModel?: any;
}
const UpdatePaymentPlanChangePaymentTypeConfirmPageData = (props: Props) => {
  const { Model, PageData, LayoutModel } = props;
  useEffect(() => {
    if (LayoutModel != undefined) {
      var userid = LayoutModel?.Profiles.length>0 ? LayoutModel?.Profiles[0].DebtReference : '';
      var isLoggedIn = LayoutModel?.HasProfile;
      var lang = PageData?.Language;
      var env = LayoutModel?.Environment;
      var reg = LayoutModel?.CountryCode;
      getGTMVariables(userid, isLoggedIn, lang, reg, env,LayoutModel?.IsLoggedInUserSecured, LayoutModel?.SecuredCaseStatus);
      getGTMVariablesPageView(window.document.title, window.location.href, window.location.pathname, userid, isLoggedIn, lang, reg, env);
    }
  }
    , [LayoutModel]);

    useEffect(() => {
      if (Model.AdyenForm.IsPaymentError) {
        var tagManagerArgs: any;
        tagManagerArgs = {
          dataLayer: {
            event: 'form_error',
            checkout_name: 'Payment Plan Update',
            error_message: 'Invalid payment data'
          }
        }
        TagManager.dataLayer(tagManagerArgs);
      }
    }, [Model.AdyenForm.IsPaymentError]);
  return (
    <div className={styles.wrapper}>
      
      <div className="Section--secondaryBg">
      
        <div className="Page-container PageContainer--transparent">
          <section className="Section Section--portal">
          <div className={styles.container}>
            <ChangePlanHeader Headingtext={PageData?.PaymentPlanHeader} />

            <RepaymentList
                    Heading={PageData?.PlanDetailsHeadingLabel}
                    BalanceLabel={PageData?.PlanDetailsCurrentBalanceLabel}
                    BalanceAmount={Model.PlanDetails.PlanDetailsCurrentBalance}                    
                    Monthlylabel={PageData?.PlanDetailsNumberofInstallmentsLabel}                    
                    Mothlyamount={Model.PlanDetails.PlanDetailsNumberofInstallments}
                    Currencysymbol={Model?.FormattedCurrencySymbol}                    
                    Finallabel={PageData.PlanDetailsFinalPaymentAmountLabel}
                    FinalAmount={Model.PlanDetails.PlanDetailsFinalPaymentAmount}
                    Totaltext={PageData?.PlanDetailsTotalPlanLabel}
                    Totalamount={Model.PlanDetails.PlanDetailsCurrentBalance} 
                    PaymentMethodLabel = {PageData?.PlanDetailsPaymentMethodLabel}                                                         
                    PaymentMethod = {Model.PlanDetails.PlanDetailsPaymentMethod}
                    CustomerNumberLabel = {PageData?.PlanDetailsCustomerNumberLabel}
                    CustomerNumber = {Model.PlanDetails.PlanDetailsCustomerNumber}
                    PlanDueDate = {Model?.PlanDetails.PlanDetailsFirstPaymentDueDate}  
                    PlanDueDateInfoText = {PageData?.FirstPaymentDueDateDetails} 
                    UpdatePlanConfirm = {true}
                  /> 

            <div className="Grid Grid--gutterH Grid--white GridWhite--smFull">
              <div className="Grid-cell">
                <div className="CreateRepaymentPlan-introText Payment_General_Info">
                  {PageData.PaymentInformationText}
                  {PageData.SepaAgreementText != null &&
                    PageData.SepaAgreementText.IsEmpty == false &&
                    Model.PaymentMethod.type == 'sepadirectdebit' && (
                      <p className="CreateRepaymentPlan__plainText">
                        {PageData?.SepaAgreementText}
                      </p>
                    )}
                  {(Model.IsInEditMode ||
                    Model.PageDataBase.IsPdfDownloadVisible) && (
                    <div className="Text--medium u-marginTxsm">
                      {PageData.PdfDownloadText}
                    </div>
                  )}
                </div>
                <div className="CreateRepaymentPlan-divider"></div>
              </div>
              <div className="Grid-cell">
                <div className="Cardpayment">
                  <div id={Model.AdyenForm.FormRootNodeId}>
                    <PaymentContainer Model={Model} PageData={PageData} IsConfirmPaymentPlan={true} />
                    {Model.AdyenForm.IsPaymentError && (
                      <div className="adyen-payment-error">
                        {PageData.AdyenPaymentError}
                      </div>
                    )}
                  </div>

                  <br style={{ clear: 'both' }} />
                </div>
              </div>
            </div>
            {/* <RepaymentContainer {...props} /> */}

            <div className="Grid Grid--gutterH">
              <div className="Grid-cell u-textCenter">
                <PageLink
                  url={Model.ChangePlanPaymentMethodPageUrl}
                  text={PageData.ButtonBackLabel}
                  className="Button Button--gray Button_Width_Full_UpdateConfirm"
                />
              </div>
            </div>
            </div>
          </section>
        </div>
        </div>
      </div>
    
  );
};

export default UpdatePaymentPlanChangePaymentTypeConfirmPageData;
